<script>
  import { onMount, getContext } from 'svelte';
  export let item;
  import Tooltip from './Tooltip.svelte';
  import { formatValue } from '../util/formatting';

  // $: {
  //   console.log(item);
  // }
</script>

<style lang="scss">
  @import './styles/theme.scss';
  .row {
    display: flex;
    flex-direction: row;
    min-width: 10em;
  }
  h3 {
    margin: 0;
  }
  .key {
    flex-grow: 0;
    color: $c-gray-2;
    padding: 0 1em 0 0;
    width: 10em;
  }
  .value {
    text-align: right;
    width: 3em;
  }
</style>

{#if item}
  <Tooltip width="{400}">
    <h3>{item.label}</h3>
    <div>{item.industry}</div>
    <hr />
    <div class="row">
      <div class="key">ROCE</div>
      <div class="value">{formatValue(item.roce, 'roce')}</div>
    </div>
    <div class="row">
      <div class="key">return_on_sales</div>
      <div class="value">
        {formatValue(item.return_on_sales, 'returnOnSales')}
      </div>
    </div>
    <div class="row">
      <div class="key">capital_turnover</div>
      <div class="value">
        {formatValue(item.capital_turnover, 'capitalTurnOver')}
      </div>
    </div>

  </Tooltip>
{/if}
